// 13-section renderer for the paid report page. Verbatim from
// PaidReport.jsx (W2c). The per-section "What this section answers"
// lookup is colocated here because it's only read by this component.
//
// CRITICAL: this lookup MIRRORS the Python lookup in
// backend/services/pdf_service.py:44-71 so the web UI and PDF carry
// identical per-section framing copy. If any line here changes, change
// it in pdf_service.py in lockstep so the PDF and UI stay in sync.
// No engine change.
const SECTION_WHAT_ANSWERS = {
  s1_executive_summary:
    "What this section answers: where your business stands today, in one read.",
  s2_current_state:
    "What this section answers: how each of your 8 systems is performing right now.",
  s3_lead_capture:
    "What this section answers: how well you turn interest into a captured contact, and the dollars that gap is costing.",
  s4_lead_conversion:
    "What this section answers: how much of your interest is converting to actual customers, and where it is falling out.",
  s5_followup:
    "What this section answers: what is happening to leads who don't buy on the first touch.",
  s6_booking_sales:
    "What this section answers: how easy you make it for a ready buyer to book or close.",
  s7_onboarding:
    "What this section answers: what a new customer's first 30 days look like, and where promises are lost.",
  s8_retention:
    "What this section answers: how well you keep customers once they have paid.",
  s9_operations:
    "What this section answers: how much of the business runs without you in every decision.",
  s10_automation_readiness:
    "What this section answers: how much of the business is on tools, versus on you typing.",
  s11_priority_roadmap:
    "What this section answers: which fixes will recover the most revenue first.",
  s12_roi_model:
    "What this section answers: the dollars and timeline behind each recommended fix.",
  s13_action_plan_90d:
    "What this section answers: exactly what to do in the next 30, 60, and 90 days. If you only have ten minutes, start here.",
};

export default function ReportSections({ sections }) {
  return (
    <div data-testid="paid-report-sections">
      {sections.map((s, idx) => (
        <section key={s.id} data-testid={`paid-report-section-${s.id}`} style={{ marginBottom: 48 }}>
          <div className="sf-eyebrow" style={{ marginBottom: 10 }}>Section {String(idx + 1).padStart(2, "0")}</div>
          <h2 className="sf-display" style={{ fontSize: 26, marginBottom: 10, lineHeight: 1.2 }}>{s.title}</h2>
          {SECTION_WHAT_ANSWERS[s.id] && (
            <p
              className="sf-muted-text"
              data-testid={`paid-report-what-${s.id}`}
              style={{ fontSize: 13, lineHeight: 1.55, marginBottom: 14, maxWidth: 720 }}
            >
              {SECTION_WHAT_ANSWERS[s.id]}
            </p>
          )}
          {s.id === "s13_action_plan_90d" && (
            <p
              className="sf-mono"
              data-testid="paid-report-action-plan-priority-note"
              style={{
                fontSize: 12, color: "var(--sf-gold)", letterSpacing: "0.05em",
                marginBottom: 14, padding: "8px 12px",
                borderLeft: "2px solid var(--sf-gold-dim)",
                background: "rgba(201,162,74,0.05)",
              }}
            >
              The plan is ordered top-to-bottom by estimated revenue impact. Treat the first items as <strong>Do first</strong>, the middle as <strong>Do next</strong>, and the tail as <strong>Do later</strong>.
            </p>
          )}
          <div className="sf-card">
            {(s.content || "").split("\n\n").map((para, i) => (
              <p key={`${s.id}-p-${i}`} style={{ marginBottom: 14, lineHeight: 1.7, color: "var(--sf-offwhite)", whiteSpace: "pre-line" }}>
                {para}
              </p>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}
